<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router>
      <template v-for="item in items" :key="item.index">
        <template v-if="item.subs">
          <el-sub-menu :index="item.index">
            <template #title>
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs"
                          :index="subItem.index"
                          :key="subItem.index">
                <template #title>{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem, i) in subItem.subs"
                              :key="i"
                              :index="threeItem.index">{{
                    threeItem.title
                }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else
                            :index="subItem.index"
                            :key="subItem.index +1"><i :class="subItem.icon"></i>{{
                  subItem.title
              }}</el-menu-item>
            </template>
          </el-sub-menu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index"
                        :key="item.index">
            <template #title>
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
// import bus from "../common/bus";
export default {
  data () {
    return {
      items: [
        {
          icon: "icon iconfont icon-gerenxinxi1",
          index: "1",
          title: "个人管理",
          subs: [
            // {
            //   icon: "icon iconfont icon-gerenxinxi1",
            //   index: "TeacherInfoUpdate",
            //   title: "个人信息"
            // },
            {
              icon: "icon iconfont icon-change_password",
              index: "EditPassword",
              title: "修改密码"
            }
          ],
        },
        {
          icon: "icon iconfont icon-24gl-newspaper3",
          index: "NewsInformation",
          title: "新闻动态",
        },
        {
          icon: "icon iconfont icon-lunbo",
          index: "CarouselImage",
          title: "轮播图",
        }
      ]
    };
  },
  computed: {
    onRoutes () {
      return this.$route.path.replace("/", "");
    },
    collapse () {
      return this.$store.state.collapse
    }
  }
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar > ul {
  height: 100%;
}
</style>
